<footer class="relative">
  <img
    class="hidden lg:block w-full bg-white"
    [src]="env.footerComponent.bannerImages.desktop.url"
    [ngStyle]="env.footerComponent.bannerImages.desktop.style"
    [alt]="env.footerComponent.bannerImages.desktop.altText" />
  <img
    class="block lg:hidden w-full bg-white"
    [src]="env.footerComponent.bannerImages.mobile.url"
    [ngStyle]="env.footerComponent.bannerImages.mobile.style"
    [alt]="env.footerComponent.bannerImages.mobile.altText" />
  <section
    class="footer-text w-full bottom-0 flex flex-column lg:flex-row align-items-center px-6 py-6 md:py-5 bg-white"
    [style.color]="env.footerComponent.textColor || '#FFFFFF'"
    [ngStyle]="env.footerComponent.style">
    <p
      class="m-0 font-poppins text-lg md:text-3xl lg:text-lg flex md:align-items-center font-medium mb-3 md:mb-0">
      {{ env.staticTextContents.footerComponent.poweredBy }}
      <span class="ml-1">
        <img
          [src]="env.footerComponent.razorpayLogo.url"
          [ngStyle]="env.footerComponent.razorpayLogo.style"
          alt="Razorpay" />
      </span>
    </p>
    <div class="p-1 pl-3 flex flex-wrap justify-content-center">
      <p
        class="m-0 text-xs pr-2 white-space-nowrap"
        data-testid="copyright-text">
        © {{ currentYear }}
      </p>
      <a
        *ngIf="env.footerComponent.privacyPolicyLink"
        [href]="env.footerComponent.privacyPolicyLink"
        class="text-xs underline border-left-1 px-2 white-space-nowrap footer-links"
        [style.color]="env.footerComponent.textColor || '#FFFFFF'"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="privacy-policy-link">
        {{ env.staticTextContents.footerComponent.privacyPolicyLabel }}
      </a>
      <a
        *ngIf="env.footerComponent.termsAndConditionsLink"
        [href]="env.footerComponent.termsAndConditionsLink"
        class="text-xs underline border-left-1 px-2 white-space-nowrap footer-links"
        [style.color]="env.footerComponent.textColor || '#FFFFFF'"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="terms-link">
        {{ env.staticTextContents.footerComponent.termsAndConditionsLabel }}
      </a>
      <a
        *ngIf="env.footerComponent.faqLink"
        [href]="env.footerComponent.faqLink"
        class="text-xs underline border-left-1 px-2 white-space-nowrap footer-links"
        [style.color]="env.footerComponent.textColor || '#FFFFFF'"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="faq-link">
        {{ env.staticTextContents.footerComponent.faqLabel }}
      </a>
      <a
        *ngIf="env.footerComponent.emailId"
        [href]="'mailto:' + env.footerComponent.emailId"
        class="text-xs underline border-left-1 px-2 white-space-nowrap footer-links mt-2 md:mt-0"
        [style.color]="env.footerComponent.textColor || '#FFFFFF'"
        target="_blank"
        rel="noopener noreferrer">
        {{ env.footerComponent.emailId }}
      </a>
    </div>
  </section>
</footer>
